import LWLink from './LWLink';
import ConnectedLWLink from './ConnectedLWLink';

export { LWLink };
export default ConnectedLWLink;
